<ng-select [items]="items()"
           bindLabel="displayName"
           class="custom"
           [multiple]="multiSelect()"
           (change)="modelChanged($event)">
</ng-select>